import React from 'react'
import Loader from '../../Constant/Loader'
import AdminAppBar from '../../adminComponents/AdminAppBar'
import { ToastContainer } from 'react-toastify'
import BackArrows from '../../Form/BackArrow/BackArrows'
import { useNavigate } from 'react-router-dom'
import { useState } from 'react'
import { getIcons } from '../../Constant/Constant'

const LinkUploaderTemplate = () => {
  const [loading, setLoading] = useState(false);
      const navigate = useNavigate();
      const icons = getIcons();
    
      const handleBack = () => {
        navigate(-1);
      };
      const handleAddTemplate = () => {
      }
  return (
    <div className="bg-appGrayBackground pb-10 pt-14">
    {loading && <Loader />}
    <AdminAppBar />
    <ToastContainer />
    <div className="mt-14 px-20 xl:px-6 relative flex justify-between gap-5">
      <div className="flex gap-6">
        <BackArrows onClick={handleBack} />
        <div>
          <h1 className="text-4xl font-semibold whitespace-nowrap">
            New Link
          </h1>
        </div>
      </div>
      <div>
        <button
          onClick={handleAddTemplate}
          className="border-2 whitespace-nowrap bg-customGreen rounded-md font-semibold p-1 px-5 w-fit text-lg text-white h-10 text-center"
        >
          Add Template
        </button>
      </div>
    </div>
      

      <div className="mx-20 mt-5 bg-white rounded-lg shadow-md">
        <div className="flex flex-col gap-5 px-20 pt-2 pb-12">
        <div className="flex  gap-5 items-center mt-12">
            <div className="">
              <h2 className="text-3xl font-medium text-gray-900">
              Content Group : 
              </h2>
            </div>
            <div>
              <h2 className="text-2xl ml-12 font-bold text-gray-900">
              Festiva Wish
              </h2>
            </div>
          </div>

          <div className="flex gap-5 items-center mt-10">
            <div className="w-1/3">
              <h2 className="text-3xl font-medium text-gray-900 whitespace-nowrap">
              Link Title
              </h2>
            </div>
            <div className="flex flex-col w-full ">
              <input
                type="text"
                placeholder="Image Title"
                className="px-3 border-2 bg-stone-100 border-stone-200 rounded-xl w-full h-10"
              />
           
            </div>
          </div>


          <div className="flex gap-5 items-center mt-10">
            <div className="w-1/3">
              <h2 className="text-3xl font-medium text-gray-900 whitespace-nowrap">
              Paste Link
              </h2>
            </div>
            <div className="flex flex-col w-full ">
              <input
                type="text"
                placeholder="Paste Link"
                className="px-3 border-2 bg-stone-100 border-stone-200 rounded-xl w-full h-10"
              />
           
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default LinkUploaderTemplate